import { render } from "./SourcesList.vue?vue&type=template&id=79c5dd96&scoped=true"
import script from "./SourcesList.vue?vue&type=script&lang=js"
export * from "./SourcesList.vue?vue&type=script&lang=js"

import "./SourcesList.vue?vue&type=style&index=0&id=79c5dd96&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c5dd96"]])

export default __exports__